<div
  [ngClass]="cssClass()"
  class="project-status-badge">
  @if (useIcon()) {
    <span
      [ngClass]="iconClass()"
      class="project-status-icon"></span>
  }
  {{ translationKey() | translate }}
</div>
